import crmCustomerType from './crm-customer-type.js';

export const getVatPayerOptions = async () => [
  { value: 0, label: 'Nie jest płatnikiem VAT' },
  { value: 1, label: 'Jest płatnikiem VAT' }
];

export const getClientStatusOptions = async () => [
  { value: 'aktywny', label: 'Aktywny' },
  { value: 'nieaktywny', label: 'Nieaktywny' }
];

export const getCompanyTypeOptions = async () => [
  { value: 0, label: 'Osoba fizyczna' },
  { value: 1, label: 'Firma' }
];

export const getAccountingFormOptions = async () => [
  { value: 'ryczałt', label: 'Ryczałt' },
  { value: 'kpir', label: 'KPiR' },
  { value: 'Księgi handlowe', label: 'Księgi handlowe' }
];

export const getAgreementOptions = async () => [
  { value: 1, label: 'Jest umowa' },
  { value: 0, label: 'Brak umowy' }
];

export const getCrmCustomerTypeOptions = async () => [
  {
    value: crmCustomerType.CRM_VALUE,
    label: 'kontrahent'
  },
  {
    value: crmCustomerType.CRM_SIMPLIFIED_VALUE,
    label: 'kontrahent uproszczony'
  },
  {
    value: crmCustomerType.CRM_AUTOMATIC_VALUE,
    label: 'kontrahent automatyczny'
  }
]; 